var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewFeedbackImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473,
    height: 338,
    viewBox: "0 0 473 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4700_27908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.448 150.884C421.089 160.751 513.974 215.945 453.336 337.086H20.4947C9.17395 337.086 0.000946045 329.429 0.000946045 319.984V159.383C5.56183 -27.5769 217.711 -53.4198 282.994 99.7035C294.262 126.157 321.327 145.987 354.448 150.884Z",
    fill: "url(#paint0_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.768 306.64C387.768 306.64 419.982 293.244 423.594 278.801C427.206 264.358 397.919 269.25 375.54 298.642C375.54 298.642 408.598 243.206 388.03 239.194C367.463 235.182 356.3 293.334 356.3 293.334C356.3 293.334 350.487 264.732 337.039 266.132C323.59 267.533 331.393 289.56 353.594 306.625H387.768V306.64Z",
    fill: "url(#paint1_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.958 304.375C368.506 281.815 376.638 260.221 388.853 240.925",
    stroke: "#707070",
    strokeWidth: 0.686164,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.53 303.529C375.53 303.529 404.839 289.323 418.045 272.03",
    stroke: "#707070",
    strokeWidth: 0.686164,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.04 269.959C337.04 269.959 347.002 299.005 361.493 303.532",
    stroke: "#707070",
    strokeWidth: 0.686164,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.371 305.523C278.371 305.523 324.254 308.914 349.393 303.922C363.936 301.037 370.286 291.632 351.193 287.873C341.567 285.977 323.233 270.518 360.713 265.72C393.402 261.528 396.846 237.685 367.842 238.17C361.029 238.286 370.422 233.874 378.743 218.445C385.135 206.576 384.036 187.821 373.235 182.47C350.456 171.198 351.056 213.99 341.757 215.994C332.828 217.922 329.383 193.827 316.958 196.797C300.719 200.682 327.068 246.409 323.835 250.495C316.937 259.204 304.047 216.089 291.947 219.565C279.823 223.012 317.683 294.855 278.371 305.523Z",
    fill: "url(#paint2_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.838 303.532C314.766 293.57 311.354 275.106 340.282 250.782C364.2 230.668 370.518 207.867 368.59 181.761",
    stroke: "#707070",
    strokeWidth: 0.686164,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.179 306.64C181.179 306.64 148.964 293.244 145.352 278.801C141.74 264.358 169.342 265.974 191.717 295.367C191.717 295.367 158.27 245.523 178.848 241.5C199.425 237.477 212.653 293.335 212.653 293.335C212.653 293.335 218.466 264.733 231.914 266.133C245.363 267.534 237.56 289.561 215.359 306.626H181.176L181.179 306.64Z",
    fill: "url(#paint3_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.989 304.378C203.989 304.378 198.499 269.447 178.019 243.234",
    stroke: "#707070",
    strokeWidth: 0.686164,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.416 303.533C193.416 303.533 166.949 279.48 150.901 275.047",
    stroke: "#707070",
    strokeWidth: 0.686164,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.907 269.959C231.907 269.959 221.945 299.005 207.454 303.532",
    stroke: "#707070",
    strokeWidth: 0.686164,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.892 305.524C107.892 305.524 62.0087 308.915 36.8706 303.923C22.3269 301.038 15.9769 291.633 35.0699 287.874C44.6958 285.978 60.8079 279.291 25.5499 265.721C-3.89534 254.378 -7.81236 235.065 20.2635 242.383C34.818 246.175 15.8524 233.864 7.53122 218.435C1.13912 206.567 2.23798 187.811 13.0392 182.461C35.8178 171.188 39.925 222.09 49.2245 224.09C58.1554 226.017 47.961 191.075 64.0103 195.688C80.0597 200.301 58.1025 240.256 62.4518 250.483C66.8011 260.71 69.6231 215.414 81.7241 218.889C93.8251 222.364 68.5694 294.855 107.892 305.524Z",
    fill: "url(#paint4_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4236 303.533C71.4963 293.571 74.9085 275.107 45.9798 250.783C22.0621 230.669 13.4596 213.345 15.3966 187.238",
    stroke: "#707070",
    strokeWidth: 0.686164,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.93 124.556H349.992C355.495 124.556 360.772 122.371 364.663 118.48C368.553 114.589 370.739 109.312 370.739 103.81V75.276C370.738 69.7745 368.551 64.4988 364.661 60.6091C360.77 56.7194 355.494 54.5343 349.992 54.5343H143.93C138.428 54.5343 133.152 56.7194 129.261 60.6091C125.371 64.4988 123.184 69.7745 123.183 75.276V103.801C123.182 106.526 123.718 109.225 124.76 111.743C125.802 114.261 127.33 116.549 129.256 118.477C131.183 120.404 133.471 121.933 135.988 122.976C138.506 124.019 141.204 124.556 143.93 124.556Z",
    fill: "url(#paint5_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M140.002 54.9137C135.269 55.8257 131.001 58.3576 127.932 62.0744C124.863 65.7912 123.184 70.4608 123.184 75.281V103.806C123.184 109.308 125.37 114.585 129.261 118.476C133.151 122.367 138.428 124.552 143.931 124.552H277.223C237.152 121.344 128.091 104.219 140.002 54.9137Z",
    fill: "#E2E2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.708 103.075C327.114 103.073 327.513 102.968 327.867 102.769L333.974 99.4516C334.179 99.3429 334.407 99.2851 334.638 99.283C334.869 99.2864 335.097 99.3441 335.302 99.4516L341.409 102.769C341.764 102.966 342.162 103.072 342.568 103.075C342.926 103.074 343.28 102.995 343.604 102.842C343.928 102.69 344.214 102.468 344.442 102.192C344.672 101.92 344.837 101.6 344.926 101.256C345.016 100.911 345.026 100.551 344.958 100.201L343.684 93.3663C343.641 93.1398 343.656 92.9061 343.728 92.687C343.799 92.468 343.926 92.2707 344.094 92.1135L349.139 87.332C349.473 87.0156 349.71 86.6109 349.824 86.165C349.937 85.7191 349.922 85.2501 349.78 84.8125C349.638 84.3749 349.374 83.9865 349.02 83.6925C348.666 83.3985 348.236 83.2108 347.78 83.1513L340.893 82.2455C340.664 82.2156 340.446 82.1279 340.26 81.9908C340.074 81.8536 339.926 81.6714 339.829 81.4613L336.839 75.1878C336.641 74.7718 336.329 74.4205 335.939 74.1745C335.55 73.9285 335.098 73.7979 334.638 73.7979C334.177 73.7979 333.726 73.9285 333.336 74.1745C332.946 74.4205 332.634 74.7718 332.436 75.1878L329.446 81.4613C329.348 81.6702 329.199 81.8513 329.013 81.9882C328.828 82.1252 328.611 82.2136 328.382 82.2455L321.495 83.1513C321.038 83.2099 320.606 83.3979 320.252 83.6931C319.898 83.9882 319.635 84.3784 319.494 84.8177C319.348 85.2545 319.33 85.7245 319.444 86.171C319.558 86.6176 319.798 87.0217 320.136 87.3349L325.181 92.1165C325.347 92.2751 325.472 92.4725 325.544 92.6911C325.615 92.9098 325.632 93.1427 325.591 93.3692L324.317 100.204C324.246 100.554 324.255 100.914 324.345 101.259C324.434 101.604 324.601 101.924 324.833 102.195C325.062 102.471 325.348 102.692 325.672 102.844C325.996 102.996 326.35 103.075 326.708 103.075Z",
    fill: "url(#paint6_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.639 74.3321C334.279 74.3275 333.925 74.4275 333.62 74.6201C333.315 74.8128 333.073 75.0896 332.923 75.4172L329.932 81.6907C329.796 81.9786 329.59 82.2279 329.333 82.4162C329.077 82.6045 328.777 82.7257 328.462 82.769L321.574 83.6747C321.217 83.7214 320.88 83.8685 320.603 84.0989C320.326 84.3292 320.12 84.6335 320.008 84.9763C319.897 85.3191 319.885 85.6864 319.974 86.0357C320.063 86.3849 320.249 86.7019 320.511 86.9496L325.547 91.7302C325.781 91.9483 325.955 92.2225 326.052 92.5267C326.15 92.8309 326.168 93.155 326.105 93.4682L324.831 100.303C324.763 100.658 324.797 101.024 324.929 101.36C325.061 101.696 325.286 101.987 325.577 102.2C325.868 102.413 326.214 102.539 326.574 102.563C326.934 102.587 327.294 102.509 327.611 102.336L333.723 99.0202C334.004 98.8682 334.319 98.7886 334.639 98.7886C334.958 98.7886 335.273 98.8682 335.555 99.0202L341.662 102.337C341.979 102.51 342.339 102.588 342.699 102.564C343.059 102.54 343.405 102.414 343.696 102.201C343.988 101.988 344.212 101.697 344.344 101.361C344.477 101.025 344.51 100.659 344.442 100.304L343.168 93.4692C343.112 93.156 343.133 92.8337 343.23 92.5307C343.328 92.2277 343.498 91.9532 343.726 91.7312L348.77 86.9496C349.032 86.7019 349.218 86.3849 349.307 86.0357C349.396 85.6864 349.384 85.3191 349.273 84.9763C349.161 84.6335 348.955 84.3292 348.678 84.0989C348.401 83.8685 348.064 83.7214 347.707 83.6747L340.819 82.769C340.503 82.7278 340.203 82.6074 339.946 82.4189C339.689 82.2303 339.483 81.9798 339.349 81.6907L336.358 75.4172C336.206 75.0908 335.964 74.8149 335.66 74.6225C335.355 74.4301 335.002 74.3293 334.642 74.3321M334.642 73.2793C335.202 73.2763 335.751 73.4333 336.225 73.7318C336.699 74.0303 337.078 74.4579 337.317 74.9643L340.308 81.2378C340.369 81.3674 340.462 81.4796 340.578 81.5641C340.694 81.6487 340.829 81.703 340.971 81.7221L347.858 82.6278C348.413 82.7005 348.936 82.929 349.367 83.2867C349.797 83.6444 350.118 84.1168 350.291 84.6491C350.464 85.1814 350.482 85.7518 350.345 86.2942C350.207 86.8367 349.918 87.3291 349.512 87.7142L344.468 92.4958C344.364 92.595 344.286 92.7187 344.242 92.8557C344.197 92.9927 344.188 93.1386 344.215 93.28L345.489 100.115C345.569 100.542 345.554 100.982 345.445 101.403C345.336 101.824 345.135 102.215 344.858 102.55C344.581 102.885 344.233 103.154 343.84 103.34C343.447 103.525 343.018 103.621 342.583 103.622C342.089 103.621 341.603 103.495 341.171 103.254L335.063 99.9368C334.937 99.8701 334.796 99.8342 334.653 99.8319C334.509 99.8291 334.367 99.8653 334.242 99.9368L328.134 103.254C327.644 103.52 327.088 103.642 326.531 103.606C325.974 103.569 325.439 103.375 324.987 103.047C324.536 102.719 324.187 102.269 323.981 101.751C323.774 101.232 323.719 100.666 323.821 100.117L325.095 93.282C325.122 93.1405 325.113 92.9947 325.069 92.8577C325.025 92.7207 324.947 92.597 324.843 92.4978L319.798 87.7162C319.392 87.331 319.104 86.8387 318.966 86.2962C318.828 85.7537 318.847 85.1833 319.02 84.651C319.193 84.1188 319.513 83.6464 319.944 83.2887C320.374 82.9309 320.897 82.7025 321.452 82.6298L328.339 81.724C328.481 81.7032 328.615 81.6482 328.731 81.5639C328.846 81.4795 328.94 81.3683 329.003 81.2398L331.993 74.9663C332.224 74.4582 332.598 74.0283 333.069 73.729C333.541 73.4298 334.089 73.2742 334.647 73.2813L334.642 73.2793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.035 103.075C283.441 103.073 283.839 102.968 284.193 102.769L290.301 99.4516C290.506 99.3429 290.733 99.2851 290.965 99.283C291.196 99.2864 291.423 99.3441 291.628 99.4516L297.736 102.769C298.09 102.966 298.489 103.072 298.895 103.075C299.253 103.074 299.606 102.995 299.93 102.843C300.254 102.69 300.541 102.468 300.769 102.192C300.998 101.92 301.164 101.6 301.253 101.256C301.342 100.911 301.353 100.551 301.285 100.201L300.01 93.3663C299.967 93.1398 299.982 92.9061 300.054 92.687C300.126 92.468 300.252 92.2707 300.421 92.1135L305.465 87.332C305.799 87.0156 306.037 86.6109 306.15 86.165C306.264 85.7191 306.249 85.2501 306.106 84.8125C305.964 84.3749 305.701 83.9865 305.347 83.6925C304.993 83.3985 304.563 83.2108 304.107 83.1513L297.22 82.2455C296.99 82.2156 296.773 82.1279 296.587 81.9908C296.4 81.8536 296.252 81.6714 296.156 81.4613L293.165 75.1878C292.967 74.7718 292.655 74.4205 292.266 74.1745C291.876 73.9285 291.425 73.7979 290.964 73.7979C290.503 73.7979 290.052 73.9285 289.663 74.1745C289.273 74.4205 288.961 74.7718 288.763 75.1878L285.772 81.4613C285.674 81.6702 285.526 81.8513 285.34 81.9882C285.154 82.1252 284.937 82.2136 284.709 82.2455L277.822 83.1513C277.365 83.2108 276.935 83.3985 276.581 83.6925C276.227 83.9865 275.964 84.3749 275.822 84.8125C275.68 85.2501 275.664 85.7191 275.778 86.165C275.891 86.6109 276.129 87.0156 276.463 87.332L281.507 92.1135C281.674 92.2722 281.799 92.4696 281.87 92.6882C281.942 92.9068 281.959 93.1398 281.918 93.3663L280.644 100.201C280.573 100.551 280.582 100.911 280.671 101.256C280.761 101.601 280.928 101.922 281.159 102.192C281.388 102.468 281.674 102.69 281.999 102.843C282.323 102.995 282.676 103.074 283.035 103.075Z",
    fill: "url(#paint7_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.961 74.3321C290.6 74.3275 290.246 74.4276 289.942 74.6202C289.637 74.8128 289.395 75.0897 289.244 75.4172L286.254 81.6907C286.118 81.9786 285.912 82.228 285.655 82.4163C285.398 82.6045 285.099 82.7258 284.783 82.769L277.896 83.6747C277.539 83.7215 277.202 83.8685 276.925 84.0989C276.648 84.3293 276.441 84.6335 276.33 84.9763C276.219 85.3191 276.207 85.6864 276.296 86.0357C276.385 86.385 276.571 86.7019 276.833 86.9497L281.877 91.7313C282.11 91.9494 282.284 92.2235 282.382 92.5277C282.479 92.8319 282.498 93.156 282.435 93.4692L281.16 100.304C281.092 100.659 281.126 101.025 281.258 101.361C281.39 101.697 281.615 101.988 281.906 102.201C282.198 102.414 282.544 102.54 282.904 102.564C283.264 102.588 283.623 102.51 283.94 102.337L290.049 99.0203C290.329 98.8682 290.642 98.7885 290.96 98.7885C291.279 98.7885 291.592 98.8682 291.871 99.0203L297.979 102.337C298.296 102.51 298.656 102.588 299.016 102.564C299.376 102.54 299.722 102.414 300.013 102.201C300.304 101.988 300.529 101.697 300.661 101.361C300.793 101.025 300.827 100.659 300.759 100.304L299.485 93.4692C299.429 93.156 299.45 92.8338 299.547 92.5307C299.644 92.2277 299.815 91.9532 300.043 91.7313L305.087 86.9497C305.349 86.7019 305.535 86.385 305.624 86.0357C305.713 85.6864 305.701 85.3191 305.59 84.9763C305.478 84.6335 305.272 84.3293 304.995 84.0989C304.718 83.8685 304.381 83.7215 304.023 83.6747L297.136 82.769C296.82 82.7279 296.52 82.6074 296.262 82.4189C296.005 82.2304 295.8 81.9799 295.666 81.6907L292.675 75.4172C292.527 75.0905 292.286 74.814 291.984 74.6214C291.681 74.4287 291.328 74.3282 290.97 74.3321M290.97 73.2793C291.53 73.2763 292.079 73.4333 292.553 73.7318C293.027 74.0303 293.406 74.4579 293.645 74.9644L296.635 81.2379C296.697 81.3674 296.79 81.4796 296.906 81.5642C297.022 81.6487 297.157 81.703 297.299 81.7221L304.186 82.6278C304.741 82.7006 305.264 82.929 305.695 83.2867C306.125 83.6445 306.445 84.1168 306.618 84.6491C306.791 85.1814 306.81 85.7518 306.672 86.2943C306.535 86.8368 306.246 87.3291 305.84 87.7143L300.795 92.4958C300.691 92.595 300.613 92.7188 300.569 92.8558C300.525 92.9927 300.516 93.1386 300.543 93.28L301.817 100.115C301.897 100.542 301.882 100.982 301.772 101.403C301.663 101.824 301.463 102.215 301.186 102.55C300.908 102.885 300.561 103.154 300.168 103.34C299.774 103.525 299.345 103.622 298.91 103.622C298.416 103.622 297.931 103.495 297.499 103.254L291.391 99.9368C291.264 99.8702 291.124 99.8342 290.98 99.8319C290.837 99.8304 290.695 99.8666 290.57 99.9368L284.462 103.254C283.971 103.52 283.415 103.642 282.859 103.606C282.302 103.569 281.766 103.375 281.315 103.047C280.864 102.719 280.515 102.269 280.308 101.751C280.102 101.232 280.047 100.666 280.149 100.117L281.423 93.282C281.45 93.1406 281.441 92.9947 281.396 92.8577C281.352 92.7207 281.275 92.597 281.17 92.4978L276.126 87.7162C275.72 87.3311 275.431 86.8387 275.293 86.2962C275.156 85.7538 275.174 85.1834 275.347 84.6511C275.52 84.1188 275.841 83.6464 276.271 83.2887C276.702 82.931 277.225 82.7025 277.78 82.6298L284.667 81.7241C284.808 81.7032 284.943 81.6483 285.058 81.5639C285.174 81.4795 285.267 81.3683 285.33 81.2398L288.321 74.9663C288.551 74.46 288.922 74.0311 289.391 73.7317C289.859 73.4323 290.405 73.2752 290.961 73.2793H290.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.362 103.074C239.768 103.073 240.167 102.968 240.521 102.769L246.634 99.4476C246.838 99.339 247.066 99.2811 247.297 99.279C247.529 99.2824 247.756 99.3402 247.961 99.4476L254.069 102.765C254.423 102.963 254.822 103.068 255.227 103.071C255.585 103.07 255.939 102.991 256.263 102.839C256.587 102.686 256.873 102.464 257.102 102.188C257.331 101.916 257.496 101.596 257.586 101.252C257.675 100.907 257.686 100.547 257.617 100.198L256.343 93.3623C256.3 93.1358 256.315 92.9021 256.387 92.6831C256.459 92.464 256.585 92.2667 256.754 92.1096L261.798 87.328C262.132 87.0116 262.37 86.607 262.483 86.1611C262.597 85.7151 262.581 85.2462 262.439 84.8086C262.297 84.3709 262.034 83.9826 261.68 83.6886C261.326 83.3945 260.896 83.2069 260.439 83.1473L253.552 82.2416C253.323 82.2117 253.105 82.124 252.919 81.9868C252.733 81.8497 252.585 81.6675 252.489 81.4574L249.498 75.1839C249.3 74.7679 248.988 74.4166 248.598 74.1706C248.209 73.9246 247.758 73.794 247.297 73.794C246.836 73.794 246.385 73.9246 245.995 74.1706C245.606 74.4166 245.294 74.7679 245.096 75.1839L242.105 81.4574C242.007 81.6663 241.858 81.8474 241.673 81.9843C241.487 82.1212 241.27 82.2097 241.041 82.2416L234.154 83.1473C233.698 83.2069 233.268 83.3945 232.914 83.6886C232.56 83.9826 232.297 84.3709 232.155 84.8086C232.012 85.2462 231.997 85.7151 232.111 86.1611C232.224 86.607 232.462 87.0116 232.796 87.328L237.84 92.1096C238.007 92.2682 238.131 92.4656 238.203 92.6843C238.275 92.9029 238.291 93.1359 238.251 93.3623L236.976 100.198C236.905 100.547 236.915 100.908 237.004 101.253C237.093 101.598 237.26 101.918 237.492 102.188C237.72 102.464 238.005 102.687 238.328 102.84C238.652 102.993 239.005 103.073 239.362 103.074Z",
    fill: "url(#paint8_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.293 74.3321C246.933 74.3275 246.579 74.4275 246.274 74.6201C245.97 74.8128 245.727 75.0896 245.577 75.4172L242.586 81.6907C242.45 81.9786 242.245 82.2279 241.988 82.4162C241.731 82.6045 241.431 82.7257 241.116 82.769L234.229 83.6747C233.871 83.7214 233.535 83.8685 233.257 84.0989C232.98 84.3292 232.774 84.6335 232.663 84.9763C232.551 85.3191 232.54 85.6864 232.628 86.0357C232.717 86.3849 232.904 86.7019 233.165 86.9496L238.21 91.7312C238.443 91.9493 238.617 92.2235 238.714 92.5277C238.812 92.8319 238.83 93.156 238.767 93.4692L237.493 100.304C237.425 100.659 237.459 101.025 237.591 101.361C237.723 101.697 237.948 101.988 238.239 102.201C238.53 102.414 238.876 102.54 239.236 102.564C239.596 102.588 239.956 102.51 240.273 102.337L246.377 99.0202C246.658 98.8663 246.973 98.7867 247.293 98.7889C247.61 98.7855 247.923 98.8653 248.199 99.0202L254.307 102.337C254.624 102.51 254.984 102.588 255.344 102.564C255.704 102.54 256.05 102.414 256.341 102.201C256.632 101.988 256.857 101.697 256.989 101.361C257.121 101.025 257.155 100.659 257.087 100.304L255.813 93.4692C255.756 93.156 255.778 92.8337 255.875 92.5307C255.972 92.2277 256.142 91.9532 256.37 91.7312L261.415 86.9496C261.676 86.7019 261.863 86.3849 261.951 86.0357C262.04 85.6864 262.029 85.3191 261.917 84.9763C261.806 84.6335 261.6 84.3292 261.322 84.0989C261.045 83.8685 260.708 83.7214 260.351 83.6747L253.464 82.769C253.148 82.7278 252.847 82.6074 252.59 82.4189C252.333 82.2303 252.128 81.9798 251.994 81.6907L249.003 75.4172C248.855 75.0896 248.615 74.8124 248.312 74.6196C248.009 74.4268 247.656 74.3268 247.297 74.3321M247.297 73.2793C247.857 73.2763 248.407 73.4333 248.881 73.7318C249.354 74.0303 249.733 74.4579 249.972 74.9643L252.963 81.2378C253.025 81.3674 253.118 81.4796 253.233 81.5641C253.349 81.6487 253.484 81.703 253.627 81.7221L260.514 82.6278C261.069 82.7005 261.592 82.929 262.022 83.2867C262.453 83.6444 262.773 84.1168 262.946 84.6491C263.119 85.1814 263.138 85.7518 263 86.2942C262.862 86.8367 262.574 87.3291 262.167 87.7142L257.123 92.4958C257.019 92.595 256.941 92.7187 256.897 92.8557C256.853 92.9927 256.844 93.1386 256.87 93.28L258.145 100.115C258.224 100.542 258.209 100.982 258.1 101.403C257.991 101.824 257.791 102.215 257.513 102.55C257.236 102.885 256.888 103.154 256.495 103.34C256.102 103.525 255.673 103.621 255.238 103.622C254.744 103.621 254.258 103.495 253.827 103.254L247.719 99.9368C247.592 99.8701 247.451 99.8342 247.308 99.8319C247.164 99.8304 247.023 99.8666 246.897 99.9368L240.79 103.254C240.299 103.52 239.743 103.642 239.186 103.606C238.629 103.569 238.094 103.375 237.643 103.047C237.191 102.719 236.842 102.269 236.636 101.751C236.429 101.232 236.374 100.666 236.477 100.117L237.751 93.282C237.778 93.1405 237.768 92.9947 237.724 92.8577C237.68 92.7207 237.602 92.597 237.498 92.4978L232.454 87.7162C232.048 87.331 231.759 86.8387 231.621 86.2962C231.483 85.7537 231.502 85.1833 231.675 84.651C231.848 84.1188 232.168 83.6464 232.599 83.2887C233.029 82.9309 233.552 82.7025 234.107 82.6298L240.994 81.724C241.136 81.7032 241.27 81.6482 241.386 81.5639C241.502 81.4795 241.595 81.3683 241.658 81.2398L244.649 74.9663C244.88 74.4582 245.254 74.0283 245.725 73.729C246.196 73.4298 246.744 73.2742 247.302 73.2813L247.297 73.2793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.69 103.074C196.096 103.073 196.495 102.968 196.849 102.769L202.956 99.4515C203.158 99.3442 203.381 99.2864 203.609 99.2829C203.841 99.2864 204.068 99.3441 204.273 99.4515L210.381 102.769C210.874 103.046 211.45 103.139 212.005 103.031C212.56 102.923 213.06 102.622 213.414 102.181C213.643 101.908 213.808 101.588 213.898 101.244C213.987 100.899 213.998 100.539 213.929 100.19L212.655 93.3545C212.612 93.128 212.627 92.8943 212.699 92.6752C212.771 92.4562 212.897 92.2589 213.066 92.1017L218.11 87.3202C218.445 87.004 218.683 86.5992 218.797 86.1529C218.911 85.7066 218.896 85.2371 218.754 84.799C218.612 84.3608 218.348 83.972 217.994 83.6777C217.64 83.3835 217.209 83.1958 216.752 83.1365L209.865 82.2308C209.636 82.2009 209.418 82.1132 209.232 81.976C209.046 81.8389 208.898 81.6567 208.802 81.4466L205.811 75.1731C205.613 74.7571 205.301 74.4058 204.911 74.1598C204.522 73.9138 204.07 73.7832 203.61 73.7832C203.149 73.7832 202.698 73.9138 202.308 74.1598C201.919 74.4058 201.607 74.7571 201.409 75.1731L198.418 81.4466C198.32 81.6555 198.171 81.8366 197.986 81.9735C197.8 82.1104 197.583 82.1989 197.354 82.2308L190.467 83.1365C190.011 83.1961 189.581 83.3837 189.227 83.6778C188.873 83.9718 188.61 84.3601 188.467 84.7978C188.325 85.2354 188.31 85.7043 188.423 86.1503C188.537 86.5962 188.775 87.0008 189.109 87.3172L194.153 92.0959C194.32 92.2545 194.444 92.4519 194.516 92.6705C194.588 92.8891 194.604 93.1221 194.564 93.3486L193.289 100.184C193.218 100.533 193.228 100.894 193.317 101.239C193.406 101.584 193.573 101.904 193.805 102.175C194.035 102.453 194.323 102.677 194.648 102.833C194.974 102.988 195.329 103.07 195.69 103.074Z",
    fill: "url(#paint9_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.621 74.3321C203.261 74.3275 202.907 74.4275 202.602 74.6201C202.297 74.8128 202.055 75.0896 201.905 75.4172L198.914 81.6907C198.778 81.9786 198.572 82.2279 198.315 82.4162C198.059 82.6045 197.759 82.7257 197.444 82.769L190.556 83.6747C190.199 83.7214 189.862 83.8685 189.585 84.0989C189.308 84.3292 189.102 84.6335 188.99 84.9763C188.879 85.3191 188.867 85.6864 188.956 86.0357C189.045 86.3849 189.231 86.7019 189.493 86.9496L194.537 91.7312C194.771 91.9493 194.944 92.2235 195.042 92.5277C195.14 92.8319 195.158 93.156 195.095 93.4692L193.821 100.304C193.752 100.659 193.786 101.025 193.919 101.361C194.051 101.697 194.275 101.988 194.567 102.201C194.858 102.414 195.204 102.54 195.564 102.564C195.924 102.588 196.284 102.51 196.601 102.337L202.705 99.0202C202.984 98.8681 203.297 98.7884 203.616 98.7884C203.934 98.7884 204.247 98.8681 204.527 99.0202L210.635 102.337C210.952 102.51 211.311 102.588 211.671 102.564C212.031 102.54 212.377 102.414 212.669 102.201C212.96 101.988 213.185 101.697 213.317 101.361C213.449 101.025 213.483 100.659 213.415 100.304L212.14 93.4692C212.084 93.156 212.105 92.8337 212.203 92.5307C212.3 92.2277 212.47 91.9532 212.698 91.7312L217.742 86.9496C218.004 86.7019 218.19 86.3849 218.279 86.0357C218.368 85.6864 218.356 85.3191 218.245 84.9763C218.134 84.6335 217.927 84.3292 217.65 84.0989C217.373 83.8685 217.036 83.7214 216.679 83.6747L209.792 82.769C209.475 82.7278 209.175 82.6074 208.918 82.4189C208.661 82.2303 208.455 81.9798 208.321 81.6907L205.331 75.4172C205.183 75.0896 204.943 74.8124 204.64 74.6196C204.337 74.4268 203.984 74.3268 203.625 74.3321M203.625 73.2793C204.185 73.2763 204.734 73.4333 205.208 73.7318C205.682 74.0303 206.061 74.4579 206.3 74.9643L209.291 81.2378C209.352 81.3674 209.445 81.4796 209.561 81.5641C209.677 81.6487 209.812 81.703 209.954 81.7221L216.841 82.6278C217.396 82.7005 217.919 82.929 218.35 83.2867C218.78 83.6444 219.101 84.1168 219.274 84.6491C219.447 85.1814 219.465 85.7518 219.328 86.2942C219.19 86.8367 218.901 87.3291 218.495 87.7142L213.451 92.4958C213.347 92.595 213.269 92.7187 213.225 92.8557C213.18 92.9927 213.171 93.1386 213.198 93.28L214.472 100.115C214.552 100.542 214.537 100.982 214.428 101.403C214.319 101.824 214.118 102.215 213.841 102.55C213.564 102.885 213.216 103.154 212.823 103.34C212.43 103.525 212.001 103.621 211.566 103.622C211.072 103.621 210.586 103.495 210.154 103.254L204.046 99.9368C203.92 99.8701 203.779 99.8342 203.636 99.8319C203.492 99.8304 203.35 99.8666 203.225 99.9368L197.117 103.254C196.627 103.52 196.071 103.642 195.514 103.606C194.957 103.569 194.422 103.375 193.97 103.047C193.519 102.719 193.17 102.269 192.964 101.751C192.757 101.232 192.702 100.666 192.804 100.117L194.078 93.282C194.105 93.1405 194.096 92.9947 194.052 92.8577C194.008 92.7207 193.93 92.597 193.826 92.4978L188.781 87.7162C188.376 87.3318 188.087 86.8406 187.949 86.2992C187.811 85.7578 187.828 85.1884 188 84.6566C188.172 84.1249 188.49 83.6525 188.919 83.294C189.347 82.9356 189.868 82.7056 190.422 82.6307L197.309 81.725C197.451 81.7042 197.585 81.6492 197.701 81.5648C197.817 81.4805 197.91 81.3693 197.973 81.2408L200.964 74.9673C201.196 74.46 201.57 74.0308 202.041 73.7318C202.512 73.4327 203.059 73.2766 203.617 73.2822L203.625 73.2793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.231 75.4172L155.241 81.6907C155.105 81.9786 154.899 82.228 154.642 82.4163C154.385 82.6045 154.086 82.7258 153.77 82.769L146.883 83.6747C146.526 83.7215 146.189 83.8685 145.912 84.0989C145.635 84.3293 145.428 84.6335 145.317 84.9763C145.206 85.3191 145.194 85.6864 145.283 86.0357C145.372 86.385 145.558 86.7019 145.82 86.9497L150.861 91.7303C151.094 91.9484 151.268 92.2225 151.366 92.5267C151.463 92.8309 151.482 93.155 151.419 93.4682L150.144 100.303C150.079 100.658 150.115 101.024 150.249 101.359C150.383 101.694 150.609 101.984 150.901 102.196C151.193 102.407 151.539 102.532 151.899 102.555C152.259 102.578 152.618 102.498 152.935 102.326L159.043 99.0085C159.323 98.8581 159.636 98.7794 159.954 98.7794C160.272 98.7794 160.585 98.8581 160.865 99.0085L166.973 102.326C167.289 102.498 167.648 102.578 168.007 102.554C168.366 102.531 168.712 102.406 169.003 102.194C169.294 101.983 169.519 101.692 169.652 101.358C169.785 101.023 169.82 100.657 169.753 100.303L168.479 93.4682C168.422 93.155 168.444 92.8328 168.541 92.5298C168.638 92.2267 168.808 91.9522 169.036 91.7303L174.081 86.9487C174.342 86.7007 174.529 86.3836 174.617 86.0341C174.706 85.6846 174.694 85.3171 174.582 84.9742C174.471 84.6313 174.264 84.3271 173.987 84.0969C173.709 83.8667 173.372 83.72 173.014 83.6737L166.127 82.768C165.811 82.7269 165.51 82.6064 165.253 82.4179C164.996 82.2294 164.791 81.9789 164.657 81.6897L161.666 75.4163C161.513 75.09 161.27 74.8141 160.966 74.6209C160.662 74.4276 160.309 74.3251 159.948 74.3252C159.588 74.3253 159.235 74.428 158.931 74.6214C158.627 74.8148 158.384 75.0909 158.231 75.4172Z",
    fill: "#3427A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.832 73.6273C176.015 73.6293 176.191 73.5588 176.322 73.4313L182.61 67.1441C182.74 67.0141 182.813 66.8378 182.813 66.6539C182.813 66.4701 182.74 66.2938 182.61 66.1638C182.48 66.0338 182.303 65.9608 182.12 65.9608C181.936 65.9608 181.759 66.0338 181.629 66.1638L175.342 72.451C175.277 72.5149 175.225 72.5912 175.19 72.6753C175.155 72.7595 175.136 72.8499 175.136 72.9412C175.136 73.0324 175.155 73.1228 175.19 73.207C175.225 73.2911 175.277 73.3674 175.342 73.4313C175.475 73.5569 175.65 73.627 175.832 73.6273Z",
    fill: "url(#paint10_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.306 67.2774C159.369 67.2127 159.419 67.136 159.453 67.0519C159.486 66.9678 159.503 66.8778 159.502 66.7873V57.8936C159.502 57.7093 159.428 57.5325 159.298 57.4022C159.168 57.2718 158.991 57.1986 158.807 57.1986C158.622 57.1986 158.446 57.2718 158.315 57.4022C158.185 57.5325 158.112 57.7093 158.112 57.8936V66.7823C158.114 66.9194 158.156 67.0529 158.233 67.1662C158.31 67.2796 158.418 67.3679 158.545 67.4201C158.672 67.4723 158.811 67.4861 158.945 67.4599C159.08 67.4336 159.204 67.3685 159.302 67.2725L159.306 67.2774Z",
    fill: "url(#paint11_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.13 74.4801C143.132 74.2972 143.061 74.121 142.934 73.99L136.647 67.7028C136.582 67.6384 136.506 67.5874 136.422 67.5525C136.338 67.5177 136.247 67.4998 136.156 67.4998C136.065 67.4998 135.975 67.5177 135.891 67.5525C135.807 67.5874 135.731 67.6384 135.666 67.7028C135.602 67.7671 135.551 67.8435 135.516 67.9276C135.481 68.0117 135.463 68.1019 135.463 68.1929C135.463 68.2839 135.481 68.374 135.516 68.4581C135.551 68.5422 135.602 68.6186 135.666 68.683L141.954 74.9702C142.017 75.0354 142.094 75.0872 142.178 75.1226C142.262 75.158 142.352 75.1762 142.444 75.1762C142.535 75.1762 142.625 75.158 142.709 75.1226C142.794 75.0872 142.87 75.0354 142.934 74.9702C142.999 74.9067 143.05 74.8303 143.084 74.7459C143.117 74.6615 143.133 74.5709 143.13 74.4801Z",
    fill: "url(#paint12_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.791 91.0039C136.726 90.9405 136.649 90.8905 136.565 90.8569C136.481 90.8232 136.391 90.8066 136.3 90.8079H127.412C127.227 90.8079 127.051 90.8811 126.92 91.0114C126.79 91.1418 126.717 91.3185 126.717 91.5029C126.717 91.6872 126.79 91.864 126.92 91.9943C127.051 92.1246 127.227 92.1978 127.412 92.1978H136.295C136.432 92.196 136.565 92.1539 136.678 92.0769C136.792 91.9999 136.88 91.8913 136.932 91.7646C136.985 91.6378 136.998 91.4986 136.972 91.364C136.946 91.2295 136.881 91.1057 136.785 91.0078L136.791 91.0039Z",
    fill: "url(#paint13_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.982 107.18C143.799 107.178 143.623 107.248 143.492 107.376L137.204 113.663C137.074 113.793 137.001 113.969 137.001 114.153C137.001 114.337 137.074 114.513 137.204 114.643C137.334 114.773 137.511 114.846 137.694 114.846C137.878 114.846 138.055 114.773 138.185 114.643L144.472 108.356C144.537 108.292 144.589 108.216 144.624 108.132C144.659 108.048 144.678 107.957 144.678 107.866C144.678 107.775 144.659 107.684 144.624 107.6C144.589 107.516 144.537 107.44 144.472 107.376C144.341 107.248 144.164 107.178 143.982 107.18Z",
    fill: "url(#paint14_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.517 113.53C160.454 113.594 160.404 113.671 160.37 113.755C160.337 113.839 160.32 113.929 160.321 114.02V122.909C160.321 123.093 160.394 123.27 160.525 123.4C160.655 123.53 160.832 123.604 161.016 123.604C161.2 123.604 161.377 123.53 161.508 123.4C161.638 123.27 161.711 123.093 161.711 122.909V114.02C161.711 113.928 161.693 113.838 161.658 113.754C161.624 113.669 161.572 113.593 161.508 113.528C161.443 113.464 161.367 113.412 161.282 113.377C161.198 113.343 161.107 113.325 161.016 113.325C160.923 113.321 160.83 113.337 160.744 113.372C160.658 113.408 160.581 113.461 160.517 113.53Z",
    fill: "url(#paint15_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.692 106.327C176.69 106.51 176.761 106.686 176.888 106.817L183.175 113.104C183.305 113.234 183.482 113.307 183.665 113.307C183.849 113.307 184.026 113.234 184.156 113.104C184.286 112.974 184.359 112.798 184.359 112.614C184.359 112.43 184.286 112.254 184.156 112.124L177.868 105.837C177.804 105.772 177.728 105.72 177.644 105.684C177.56 105.649 177.469 105.631 177.378 105.631C177.287 105.631 177.197 105.649 177.112 105.684C177.028 105.72 176.952 105.772 176.888 105.837C176.823 105.9 176.772 105.977 176.738 106.061C176.704 106.146 176.689 106.236 176.692 106.327Z",
    fill: "url(#paint16_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.032 89.7884C183.097 89.8519 183.173 89.9018 183.258 89.9355C183.342 89.9691 183.432 89.9858 183.522 89.9845H192.411C192.595 89.9845 192.772 89.9113 192.902 89.7809C193.033 89.6506 193.106 89.4738 193.106 89.2895C193.106 89.1052 193.033 88.9284 192.902 88.7981C192.772 88.6677 192.595 88.5945 192.411 88.5945H183.522C183.431 88.5944 183.341 88.6123 183.256 88.6472C183.172 88.682 183.095 88.7332 183.031 88.7978C182.966 88.8623 182.915 88.939 182.88 89.0234C182.845 89.1078 182.827 89.1982 182.827 89.2895C182.826 89.3822 182.843 89.4742 182.879 89.5599C182.914 89.6457 182.966 89.7234 183.032 89.7884Z",
    fill: "url(#paint17_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.385 61.6204C148.385 61.9887 148.494 62.3488 148.699 62.6551C148.903 62.9614 149.194 63.2001 149.535 63.3411C149.875 63.482 150.249 63.5189 150.611 63.447C150.972 63.3752 151.304 63.1978 151.564 62.9373C151.825 62.6769 152.002 62.345 152.074 61.9837C152.146 61.6224 152.109 61.248 151.968 60.9077C151.827 60.5673 151.588 60.2765 151.282 60.0718C150.976 59.8672 150.616 59.7579 150.247 59.7579C149.753 59.7579 149.28 59.9542 148.93 60.3034C148.581 60.6527 148.385 61.1264 148.385 61.6204Z",
    fill: "url(#paint18_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.964 112.12C193.934 112.12 193.099 111.285 193.099 110.256C193.099 109.226 193.934 108.391 194.964 108.391C195.993 108.391 196.828 109.226 196.828 110.256C196.828 111.285 195.993 112.12 194.964 112.12Z",
    fill: "url(#paint19_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.438 84.601C125.438 84.9693 125.547 85.3294 125.751 85.6357C125.956 85.942 126.247 86.1807 126.587 86.3216C126.928 86.4626 127.302 86.4995 127.663 86.4276C128.025 86.3558 128.356 86.1784 128.617 85.9179C128.877 85.6574 129.055 85.3256 129.127 84.9643C129.198 84.603 129.162 84.2286 129.021 83.8882C128.88 83.5479 128.641 83.257 128.335 83.0524C128.028 82.8478 127.668 82.7385 127.3 82.7385C126.806 82.7385 126.332 82.9347 125.983 83.284C125.634 83.6333 125.438 84.107 125.438 84.601Z",
    fill: "url(#paint20_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.61 148.694C153.671 142.039 151.28 134.319 149.091 126.505C148.938 126.037 148.614 125.644 148.185 125.403C147.756 125.163 147.251 125.093 146.773 125.207C146.294 125.321 145.876 125.611 145.601 126.019C145.326 126.427 145.215 126.924 145.289 127.411C146.89 135.594 148.712 143.829 152.429 151.464C152.601 151.822 152.843 152.142 153.141 152.404C153.44 152.666 153.788 152.865 154.166 152.989C154.543 153.113 154.942 153.159 155.338 153.124C155.733 153.089 156.118 152.975 156.468 152.788C156.819 152.601 157.128 152.344 157.376 152.034C157.625 151.724 157.808 151.367 157.915 150.985C158.021 150.602 158.049 150.202 157.997 149.808C157.945 149.414 157.814 149.035 157.611 148.694L157.61 148.694Z",
    fill: "#FFB9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.064 144.608C161.115 143.615 160.336 142.473 159.757 141.227C159.737 141.185 159.726 141.164 159.673 141.325C159.575 141.585 159.405 141.812 159.183 141.978C159.026 142.115 158.823 142.19 158.615 142.189C159.036 142.009 160.047 142.378 160.837 142.642C161.324 142.818 161.862 142.793 162.331 142.574C162.801 142.355 163.165 141.959 163.343 141.472C164.038 139.155 161.237 138.366 159.3 137.786C158.735 137.645 158.145 137.643 157.58 137.782C157.014 137.921 156.492 138.196 156.057 138.584C155.623 138.971 155.29 139.459 155.088 140.005C154.886 140.55 154.821 141.137 154.898 141.714C155.194 144.041 156.05 146.261 157.393 148.184C157.613 148.528 157.902 148.822 158.242 149.048C158.581 149.275 158.964 149.428 159.366 149.499C159.768 149.57 160.18 149.557 160.577 149.46C160.973 149.364 161.346 149.186 161.67 148.938C161.994 148.691 162.264 148.379 162.462 148.021C162.659 147.664 162.781 147.27 162.818 146.864C162.855 146.457 162.808 146.047 162.679 145.66C162.55 145.273 162.343 144.917 162.069 144.614L162.064 144.608Z",
    fill: "#FFB9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.068 147.356C166.903 145.712 166.07 143.855 165.617 141.891C165.564 141.564 165.638 141.417 165.47 141.617C165.393 141.686 165.299 141.734 165.197 141.754C165.734 141.47 167.029 141.912 168.083 142.27C168.569 142.45 169.107 142.431 169.578 142.216C170.05 142.001 170.417 141.608 170.6 141.122C171.286 139.195 169.221 138.378 167.746 137.826C164.25 136.341 160.838 137.983 160.744 141.88C160.733 145.134 161.734 147.525 162.986 150.274C163.16 150.64 163.408 150.966 163.714 151.232C164.02 151.499 164.377 151.698 164.764 151.82C165.151 151.941 165.559 151.981 165.962 151.937C166.365 151.893 166.755 151.766 167.106 151.564C167.458 151.363 167.764 151.09 168.006 150.765C168.247 150.439 168.419 150.067 168.509 149.672C168.6 149.277 168.608 148.867 168.533 148.468C168.458 148.07 168.301 147.691 168.073 147.356H168.068Z",
    fill: "#FFB9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.332 145.324C171.077 144.8 170.869 144.254 170.711 143.692C170.658 143.503 170.595 143.724 170.331 143.766C170.047 143.829 169.994 143.745 170.121 143.682C171.437 143.639 172.933 145.398 173.712 146.588C173.898 146.852 174.173 147.04 174.486 147.116C174.8 147.192 175.131 147.152 175.417 147.003C175.703 146.853 175.925 146.605 176.041 146.304C176.158 146.003 176.161 145.67 176.05 145.367C175.102 142.86 173.954 140.575 170.995 139.512C170.453 139.362 169.887 139.321 169.33 139.393C168.773 139.465 168.236 139.648 167.75 139.93C167.264 140.213 166.84 140.59 166.502 141.039C166.164 141.488 165.919 142 165.782 142.545C165.402 144.058 165.392 145.64 165.751 147.158C165.824 147.577 165.986 147.976 166.227 148.327C166.468 148.678 166.782 148.973 167.147 149.193C167.513 149.412 167.921 149.55 168.344 149.597C168.767 149.645 169.196 149.6 169.6 149.468C170.005 149.335 170.376 149.116 170.689 148.827C171.002 148.538 171.249 148.185 171.413 147.792C171.577 147.4 171.655 146.976 171.641 146.55C171.627 146.124 171.522 145.707 171.332 145.325V145.324Z",
    fill: "#FFB9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.562 154.922C149.449 158.05 152.776 163.894 158.854 167.539C163.329 170.034 166.678 163.242 161.96 161.209C156.199 158.966 151.25 153.532 144.836 151.658C144.418 151.549 143.975 151.598 143.591 151.795C143.206 151.991 142.907 152.322 142.75 152.724C142.593 153.126 142.589 153.572 142.739 153.977C142.888 154.382 143.181 154.718 143.562 154.922Z",
    fill: "#FFB9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2802 204.951C83.4502 193.746 103.596 189.302 114.232 189.617C114.322 189.632 114.41 189.653 114.496 189.68C126.786 193.261 140.178 201.622 151.808 204.776C165.213 208.409 169.027 211.631 179.568 217.834C179.062 211.347 166.573 176.9 165.888 175.721C160.58 166.58 157.463 169.655 154.683 163.81C153.009 160.281 153.861 156.901 152.722 153.848C151.343 150.14 150.711 146.097 152.743 143.2C154.775 140.304 158.893 141.442 161.494 140.905C170.13 139.14 172.71 142.01 176.48 150.014C177.617 152.436 178.27 157.165 178.692 161.335C178.79 162.315 178.47 169.349 180.197 170.865C187.569 188.706 209.811 218.897 201.959 237.686C195.482 253.187 158.033 238.95 148.787 235.022C130.294 227.165 122.975 225.691 106.873 221.015C106.114 220.794 105.609 220.868 105.177 220.667C98.5517 217.536 77.1101 216.146 80.2802 204.951Z",
    fill: "#FFB9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.567 240.432C136.531 235.861 123.31 226.014 107.008 221.107C105.85 220.759 105.965 221.045 105.208 220.634C93.528 214.273 80.0273 206.638 64.9258 184.807C81.2702 177.467 94.4132 177.899 114.401 180.788C126.575 182.547 156.355 203.083 160.472 207.032C160.602 218.956 157.589 229.427 154.567 240.432Z",
    fill: "url(#paint21_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.106 196.221L137.959 222.982C137.959 222.982 148.038 233.345 153.882 240.242C136.19 235.598 123.103 225.952 106.997 221.107C105.839 220.759 105.954 221.045 105.197 220.634C93.5172 214.273 80.0165 206.638 64.915 184.807C65.1787 184.692 65.4414 184.586 65.7051 184.47C83.5022 192.862 114.106 196.221 114.106 196.221Z",
    fill: "url(#paint22_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.611 151.632C160.89 152.025 161.25 152.355 161.665 152.6C162.08 152.845 162.543 152.999 163.022 153.053C163.501 153.106 163.986 153.058 164.445 152.911C164.905 152.765 165.328 152.522 165.687 152.201L165.256 152.243C166.007 152.573 166.84 152.669 167.647 152.517C168.453 152.364 169.195 151.972 169.774 151.39C169.79 151.376 169.8 151.356 169.803 151.335C169.806 151.314 169.801 151.292 169.789 151.274C169.777 151.256 169.759 151.243 169.738 151.237C169.717 151.232 169.695 151.234 169.676 151.243C169.019 151.601 168.287 151.796 167.539 151.813C166.792 151.83 166.051 151.668 165.379 151.341C164.774 151.929 163.968 152.264 163.125 152.278C162.281 152.292 161.464 151.983 160.841 151.415C160.81 151.391 160.772 151.378 160.733 151.38C160.694 151.382 160.657 151.398 160.629 151.425C160.601 151.452 160.583 151.488 160.58 151.527C160.576 151.566 160.587 151.605 160.609 151.636L160.611 151.632Z",
    fill: "#FF9494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7941 394.86C27.4249 358.949 30.4685 306.777 64.2837 286.82L119.793 288.694C119.793 288.694 142.319 332.707 148.933 394.849H29.7941V394.86Z",
    fill: "url(#paint23_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4865 394.86H29.804C27.4348 358.949 30.4784 306.777 64.2935 286.82L89.063 290.422C70.4857 309.283 54.2363 327.933 54.2363 327.933C54.2363 327.933 61.8126 360.812 71.4865 394.86Z",
    fill: "url(#paint24_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.788 222.634C128.881 213.429 124.069 207.616 116.823 199.329C108.777 190.135 105.334 185.839 98.0674 183.501C97.9694 183.469 70.8757 180.783 70.8757 180.783C66.3265 180.783 52.1729 184.543 38.3976 191.767C30.4146 195.948 28.8776 208.016 32.4369 216.294L42.7891 240.408L49.687 255.088L48.5499 295.866C104.197 313.211 129.113 291.161 129.113 291.161C129.113 291.161 118.656 263.558 121.605 254.491C125.205 243.412 131.809 227.583 130.788 222.634Z",
    fill: "url(#paint25_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.533 248.75C101.533 248.75 110.242 247.118 114.128 240.799C117.771 244.524 122.95 243.674 122.95 243.674C120.235 244.908 117.425 245.918 114.546 246.696C110.304 247.89 105.936 248.58 101.533 248.75Z",
    fill: "url(#paint26_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3977 191.767C42.9068 189.408 83.2287 212.352 95.2767 250.9C99.6878 264.99 80.8673 302.264 78.5853 302.06C75.8263 301.807 72.9444 301.445 69.9397 300.975C62.6947 299.785 55.5435 298.082 48.5402 295.878L49.6773 255.1L42.7823 240.424L32.4301 216.31C28.8777 208.016 30.4157 195.958 38.3977 191.767Z",
    fill: "url(#paint27_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.149 285.377C184.175 284.601 183.037 284.058 181.822 283.787L173.955 282.049C172.41 281.711 170.803 281.777 169.29 282.239L155.326 286.514C155.326 286.514 101.038 268.535 93.3604 264.737C86.8311 248.857 69.9387 225.403 69.9387 225.403C69.9387 225.403 46.6542 223.05 48.5392 240.42C49.4136 248.434 72.108 278.174 75.4359 282.871C76.1524 283.83 76.8082 284.703 77.3846 285.462C78.2867 286.65 79.4143 287.648 80.7027 288.4C81.9911 289.151 83.4151 289.642 84.8932 289.842L154.336 299.468C157.211 304.965 166.837 301.753 169.364 301.08C171.891 300.406 173.997 304.776 176.029 304.113C178.599 303.28 184.633 301.206 186.539 300.005C186.669 299.924 186.779 299.816 186.863 299.688C186.946 299.56 187.001 299.415 187.023 299.264C187.045 299.113 187.033 298.959 186.99 298.812C186.946 298.666 186.872 298.53 186.771 298.415L178.388 288.822L183.463 290.034L189.214 293.382C189.577 293.595 189.987 293.719 190.408 293.743C190.829 293.767 191.25 293.69 191.636 293.519C191.636 293.519 192.931 292.887 192.963 292.224C192.995 291.727 187.782 287.484 185.149 285.377Z",
    fill: "#FFB9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.407 295.74L84.903 289.853C81.9187 289.445 79.2182 287.87 77.3944 285.472C76.815 284.714 76.1622 283.84 75.4457 282.882C72.1285 278.184 49.4234 248.445 48.549 240.431C48.4699 239.686 48.4418 238.937 48.4647 238.188C54.2354 243.991 65.462 253.848 65.462 253.848L87.8201 279.502L127.407 295.74Z",
    fill: "#FF9494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8878 260.682C39.5877 241.895 32.9849 226.204 30.6362 217.454C26.9711 203.838 34.1111 195.412 41.5256 192.6C56.533 186.892 69.1594 204.28 71.2551 208.872C71.2551 208.872 84.3903 236.759 85.5881 240.992C79.5538 248.529 52.3837 259.725 50.8878 260.682Z",
    fill: "url(#paint28_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1312 217.231C36.111 224.582 41.7092 231.494 47.8648 237.893C53.365 243.594 59.2406 248.921 65.4521 253.837C58.1435 257.439 51.5936 260.229 50.8771 260.682C39.5769 241.895 32.9741 226.204 30.6254 217.454C30.4882 216.938 30.3725 216.433 30.2569 215.938C30.5627 216.378 30.847 216.81 31.1312 217.231Z",
    fill: "url(#paint29_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.294 160.152C119.213 176.074 94.77 189.47 83.6178 175.295C83.3541 174.969 83.1022 174.632 82.8493 174.274C77.1728 166.407 88.0622 132.591 87.9573 132.602L85.8194 98.8919C85.8194 98.8919 81.6593 90.2884 87.9044 90.9304C114.127 103.104 116.222 122.671 109.273 148.42C108.255 152.192 109.333 156.223 111.294 160.152Z",
    fill: "url(#paint30_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57 185.004C70.57 185.004 89.4522 201.317 101.521 212.956C101.521 201.93 96.4452 185.954 96.4452 185.954C96.4452 185.954 90.8216 169.515 94.9817 160.037C92.2439 155.814 74.7095 149.685 69.9495 155.361C72.4236 164.079 70.57 185.004 70.57 185.004Z",
    fill: "#FFB9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5603 178.707C84.9141 173.923 76.6386 166.77 70.5073 157.919C70.3694 157.059 70.1832 156.208 69.9495 155.37C74.7096 149.693 92.2547 155.823 94.9818 160.046C92.6096 165.438 93.4232 173.115 94.5603 178.707Z",
    fill: "#FF9494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4429 135.898C83.0179 141.468 71.8579 142.638 61.1548 143.533C56.7633 143.901 52.3503 147.576 47.9383 147.618C46.1739 144.195 41.1982 134.107 39.8288 127.999C36.796 114.509 37.7645 101.735 50.6967 101.176C67.3146 74.2194 97.5705 92.9419 98.042 103.409C98.1998 106.99 95.9776 122.797 93.0183 135.665C92.8151 135.711 92.6207 135.789 92.4429 135.898Z",
    fill: "url(#paint31_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8813 114.868C66.252 106.58 62.4928 101.704 73.0656 100.43C73.4136 100.388 73.792 100.367 74.1508 100.332C74.5085 100.279 74.8565 98.0047 75.2035 97.9626C85.7763 96.6883 87.6407 95.0768 95.1601 101.589C104.88 110.004 106.144 131.603 106.923 137.533C109.124 154.383 107.649 162.281 97.5823 166.352C87.5457 167.952 82.4494 166.92 72.3285 162.16C64.7248 157.336 58.4092 152.554 56.8055 143.868C55.7214 137.996 57.5221 120.049 60.8813 114.868Z",
    fill: "#FFB9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4159 143.564C77.8159 145.049 80.733 145.565 83.9345 144.723C87.1359 143.881 89.411 141.978 89.0209 140.489C88.6308 139 85.7038 138.488 82.5024 139.33C79.3009 140.172 77.015 142.069 77.4159 143.564Z",
    fill: "#FF9494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.531 137.194C100.72 137.92 102.047 138.204 103.479 137.826C104.911 137.447 105.912 136.541 105.722 135.814C105.532 135.088 104.206 134.804 102.774 135.182C101.341 135.56 100.341 136.467 100.531 137.194Z",
    fill: "#FF9494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2721 132.296C88.3564 133.339 87.8721 134.223 87.1938 134.287C86.5155 134.351 85.8881 133.55 85.8038 132.507C85.7195 131.464 86.2038 130.58 86.8821 130.516C87.5604 130.452 88.178 131.253 88.2721 132.296Z",
    fill: "#713B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.648 129.379C102.722 130.316 102.29 131.127 101.668 131.18C101.045 131.233 100.492 130.505 100.404 129.568C100.317 128.631 100.762 127.821 101.385 127.768C102.007 127.715 102.564 128.442 102.648 129.379Z",
    fill: "#713B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5187 137.91C96.6889 138.805 97.1654 139.613 97.8665 140.195C98.5831 140.795 99.6143 140.985 99.729 141.332C100.213 142.396 99.0026 143.954 97.7911 144.175C97.7241 144.194 97.6661 144.236 97.6268 144.294C97.5875 144.352 97.5695 144.421 97.5757 144.491C97.582 144.56 97.6121 144.625 97.6611 144.675C97.71 144.724 97.7747 144.756 97.844 144.763C99.7819 144.91 101.74 142.614 100.719 140.729C100.087 139.803 99.2026 139.866 98.4547 139.381C97.8539 138.957 97.3747 138.382 97.0647 137.715C97.0313 137.654 96.9775 137.607 96.9128 137.582C96.848 137.557 96.7766 137.556 96.711 137.579C96.6454 137.601 96.5899 137.646 96.5544 137.706C96.5188 137.765 96.5055 137.836 96.5167 137.904L96.5187 137.91Z",
    fill: "#713B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3349 125.725C84.9235 124.282 81.8456 125.567 80.1527 127.489C79.6012 128.12 79.1469 128.83 78.8049 129.596C78.7397 129.738 78.733 129.901 78.7861 130.049C78.8392 130.196 78.948 130.317 79.0892 130.386C79.1936 130.436 79.3108 130.454 79.4254 130.436C79.54 130.419 79.6466 130.367 79.7312 130.288C80.6859 129.225 81.8283 128.346 83.1012 127.697C84.3949 127.223 85.7469 126.926 87.1202 126.815C87.2382 126.792 87.3468 126.735 87.4318 126.65C87.5168 126.565 87.5745 126.457 87.5972 126.339C87.6199 126.221 87.6066 126.099 87.5592 125.988C87.5117 125.878 87.4322 125.785 87.331 125.72L87.3349 125.725Z",
    fill: "#7B3200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9508 124.271C98.6285 123.864 99.3956 123.629 100.185 123.587C100.974 123.545 101.762 123.697 102.48 124.029C102.628 124.084 102.791 124.078 102.935 124.013C103.079 123.948 103.192 123.828 103.248 123.681C103.284 123.58 103.293 123.472 103.275 123.367C103.256 123.262 103.211 123.163 103.143 123.081C102.744 122.609 102.247 122.228 101.688 121.964C101.128 121.701 100.518 121.561 99.8995 121.554C98.5938 121.48 96.8873 122.313 96.8667 123.818C96.8718 123.942 96.9121 124.061 96.9826 124.162C97.0532 124.263 97.1512 124.342 97.2651 124.39C97.379 124.438 97.5041 124.452 97.6258 124.431C97.7474 124.409 97.8605 124.354 97.9518 124.271H97.9508Z",
    fill: "#7B3200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.658 101.745C98.0557 87.2751 84.2815 81.9995 66.0521 87.2751C35.3854 98.9967 55.0891 135.729 55.0891 135.729L59.4179 134.665L61.5449 140.416C66.8843 138.71 68.7693 133.371 67.1264 125.545C69.0643 125.072 72.3922 125.292 82.4602 122.575C98.3508 118.521 104.627 107.948 102.658 101.745Z",
    fill: "url(#paint32_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.658 101.745C98.0557 87.2751 84.2815 81.9995 66.0521 87.2751C35.3854 98.9967 55.0891 135.729 55.0891 135.729L59.4179 134.665L61.5449 140.416C66.8843 138.71 68.7693 133.371 67.1264 125.545C69.0643 125.072 72.3922 125.292 82.4602 122.575C98.3508 118.521 104.627 107.948 102.658 101.745Z",
    fill: "url(#paint33_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.242 125.873L105.597 126.81",
    stroke: "#707070",
    strokeWidth: 1.49878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1099 134.076L54.7627 135.635C54.7627 135.635 44.0635 136.517 50.7506 148.947",
    stroke: "#707070",
    strokeWidth: 1.62033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0121 130.654L98.5615 130.064",
    stroke: "#707070",
    strokeWidth: 1.49878,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9284 190.598C57.4897 204.425 32.1203 206.425 27.8759 192.24C26.4644 187.512 32.6791 181.088 39.8602 170.441C47.0414 159.794 47.2532 146.81 47.2532 146.81C47.2532 146.81 41.1237 115.859 64.0926 119.566C64.0926 119.566 60.8176 131.182 70.6748 150.075C72.9748 154.586 74.7928 159.326 76.0985 164.219C77.6678 170.199 77.5434 186.469 72.9284 190.598Z",
    fill: "url(#paint34_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5757 136.373C58.2554 135.683 56.7779 135.349 55.2892 135.405C51.677 135.71 48.9177 137.855 49.3176 142.682C49.416 145.005 50.3449 147.217 51.9354 148.913C53.5259 150.61 55.6724 151.68 57.9848 151.928C59.2591 152.086 61.3862 151.908 62.3341 150.97C61.4186 145.893 61.8087 144.783 59.5757 136.373Z",
    fill: "#FFB9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4478 130.453C56.4478 130.453 56.2684 152.179 50.6977 159.793L58.8905 159.024C59.6963 149.508 59.5163 139.933 58.3534 130.453",
    fill: "url(#paint35_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9221 140.142C57.4803 139.805 56.9715 139.566 56.4298 139.442C55.8881 139.317 55.3261 139.31 54.7815 139.421C54.2369 139.532 53.7223 139.758 53.2722 140.084C52.8221 140.41 52.447 140.828 52.172 141.311",
    stroke: "#713B24",
    strokeWidth: 1.09198,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7833 149.715C91.1491 151.516 88.9269 147.619 88.9269 147.619C88.9269 147.619 89.6434 152.913 93.8761 154.18C98.1087 155.447 97.7833 149.715 97.7833 149.715Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.405 135.182C78.8413 136.822 79.7542 138.297 81.0283 139.418C82.3024 140.54 83.8804 141.258 85.5628 141.483C87.2453 141.707 88.9566 141.428 90.4803 140.68C92.004 139.932 93.2716 138.749 94.123 137.281C94.9743 135.812 95.3711 134.124 95.2632 132.431C95.1553 130.737 94.5474 129.113 93.5166 127.764C92.4857 126.416 91.0781 125.403 89.4718 124.855C87.8655 124.306 86.1326 124.246 84.4923 124.683C83.4031 124.972 82.3816 125.474 81.4861 126.158C80.5907 126.842 79.8388 127.696 79.2736 128.671C78.7083 129.646 78.3406 130.723 78.1916 131.84C78.0426 132.957 78.1151 134.093 78.405 135.182Z",
    stroke: "#707070",
    strokeWidth: 1.587,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5723 130.095C99.7094 134.36 103.722 137.003 107.535 135.992C111.347 134.98 113.527 130.698 112.39 126.43C111.253 122.161 107.24 119.521 103.427 120.532C99.6153 121.544 97.4352 125.83 98.5723 130.095Z",
    stroke: "#707070",
    strokeWidth: 1.39879,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.212 300.099H248.242V306.418H135.212V300.099Z",
    fill: "#C3CAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.705 227.961C259.606 225.527 294.653 226.14 329.448 229.793C331.828 230.046 333.524 232.415 332.807 234.48C325.119 257.68 317.389 281.817 309.673 306.481H196.064C203.837 282.439 211.587 257.521 219.349 232.173C219.725 231.02 220.435 230.005 221.388 229.255C222.342 228.505 223.496 228.055 224.705 227.961Z",
    fill: "#C3CAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.917 227.677C263.835 225.485 298.878 226.342 333.648 230.236C336.028 230.51 337.713 232.869 337.007 234.912C329.33 257.912 321.6 281.892 313.881 306.46H200.272C208.044 282.259 215.795 257.253 223.545 231.847C223.928 230.698 224.642 229.689 225.598 228.947C226.555 228.204 227.709 227.763 228.917 227.677Z",
    fill: "url(#paint36_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.871 269.022C267.51 269.358 268.223 269.526 268.945 269.512C270.519 269.426 272.033 268.884 273.303 267.95C274.573 267.017 275.544 265.734 276.096 264.257C276.408 263.4 276.467 262.472 276.264 261.582C276.642 261.537 277.021 261.512 277.401 261.509C281.824 261.562 284.204 265.163 282.73 269.512C281.256 273.862 276.474 277.379 272.062 277.354C267.65 277.33 265.259 273.784 266.733 269.393C266.77 269.266 266.816 269.142 266.871 269.022Z",
    fill: "#C3CAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.717 306.471H200.273C207.792 283.06 215.29 258.891 222.789 234.343C228.57 273.456 255.034 301.427 274.717 306.471Z",
    fill: "url(#paint37_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.511 282.534C378.511 282.534 380.523 281.281 384.577 282.534C389.232 283.977 391.096 290.97 384.883 295.235C381.206 297.779 376.969 299.398 372.532 299.952L377.61 293.141C379.674 293.065 381.652 292.292 383.222 290.95C385.645 288.739 385.876 284.873 382.696 286.159C379.516 287.445 376.935 291.993 376.935 291.993L378.511 282.534Z",
    fill: "url(#paint38_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.534 306.798H360.556C364.806 306.798 368.918 305.282 372.152 302.524C375.387 299.766 377.533 295.946 378.206 291.749L380.166 279.48H339.927L341.887 291.749C342.56 295.946 344.705 299.765 347.939 302.523C351.173 305.281 355.284 306.797 359.534 306.798Z",
    fill: "url(#paint39_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.165 279.48L379.744 282.113C381.368 281.844 383.034 281.989 384.588 282.535C389.243 283.978 391.106 290.971 384.894 295.236C381.872 297.294 378.488 298.763 374.921 299.564C373.26 301.808 371.096 303.631 368.604 304.887C366.111 306.144 363.359 306.799 360.567 306.799H359.546C355.295 306.799 351.184 305.283 347.949 302.525C344.714 299.767 342.568 295.947 341.896 291.75L339.935 279.481H380.165V279.48ZM383.219 290.949C385.642 288.738 385.873 284.872 382.693 286.158C381.047 286.97 379.623 288.17 378.544 289.654L378.207 291.75C378.133 292.213 378.038 292.676 377.922 293.129C379.876 292.99 381.734 292.226 383.219 290.949Z",
    fill: "url(#paint40_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.277 279.48C349.119 290.896 357.987 300.933 369.319 304.481C366.644 305.997 363.621 306.791 360.547 306.788H359.525C355.275 306.787 351.163 305.272 347.929 302.514C344.694 299.756 342.548 295.936 341.875 291.739L339.915 279.47H348.276L348.277 279.48Z",
    fill: "url(#paint41_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M360.536 278.132C360.006 276.703 359.852 275.161 360.088 273.655C360.324 272.149 360.942 270.728 361.884 269.529C365.127 265.02 350.226 266.064 354.797 257.797C358.346 251.384 363.4 246.013 357.408 240.545C357.408 240.545 366.328 246.79 360.055 254.836C351.534 265.746 377.673 258.267 362.066 274.013C361.083 274.982 360.032 276.089 360.536 278.132Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.574 304.934H411.527C414.62 304.934 417.587 306.163 419.775 308.351C421.962 310.538 423.191 313.505 423.191 316.599V337.086H171.564V304.934H171.574Z",
    fill: "url(#paint42_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.574 304.934H25.1763C22.0826 304.934 19.1156 306.163 16.9281 308.351C14.7405 310.538 13.5116 313.505 13.5116 316.599V336.902H171.574V304.934Z",
    fill: "url(#paint43_linear_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.574 304.934H411.527C414.62 304.934 417.587 306.163 419.775 308.351C421.962 310.538 423.191 313.505 423.191 316.599V337.086H171.564V304.934H171.574Z",
    fill: "url(#paint44_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.574 304.934H25.1763C22.0826 304.934 19.1156 306.163 16.9281 308.351C14.7405 310.538 13.5116 313.505 13.5116 316.599V336.902H171.574V304.934Z",
    fill: "url(#paint45_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 156.066C222.273 156.066 223.273 155.763 224.123 155.194C224.974 154.626 225.636 153.819 226.028 152.874C226.419 151.929 226.521 150.889 226.322 149.886C226.122 148.883 225.63 147.962 224.907 147.239C224.184 146.516 223.262 146.023 222.259 145.824C221.256 145.624 220.217 145.727 219.272 146.118C218.327 146.509 217.519 147.172 216.951 148.022C216.383 148.873 216.08 149.872 216.08 150.895C216.08 152.266 216.625 153.581 217.595 154.551C218.564 155.52 219.879 156.065 221.251 156.066ZM221.251 146.746C222.071 146.746 222.873 146.989 223.556 147.445C224.238 147.901 224.77 148.549 225.084 149.307C225.398 150.065 225.48 150.9 225.32 151.705C225.16 152.51 224.765 153.249 224.185 153.829C223.604 154.409 222.865 154.805 222.06 154.965C221.255 155.125 220.421 155.043 219.663 154.729C218.904 154.415 218.256 153.883 217.8 153.2C217.345 152.518 217.101 151.716 217.101 150.895C217.103 149.795 217.541 148.741 218.319 147.963C219.097 147.186 220.151 146.748 221.251 146.746Z",
    fill: "url(#paint46_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9378 67.5194C45.9605 67.5194 46.9602 67.2162 47.8105 66.648C48.6608 66.0799 49.3236 65.2723 49.7149 64.3275C50.1063 63.3826 50.2087 62.343 50.0092 61.34C49.8096 60.3369 49.3172 59.4156 48.5941 58.6925C47.8709 57.9693 46.9496 57.4768 45.9466 57.2773C44.9435 57.0778 43.9039 57.1802 42.959 57.5716C42.0142 57.9629 41.2067 58.6257 40.6385 59.476C40.0703 60.3263 39.7671 61.326 39.7671 62.3487C39.7676 63.7199 40.3125 65.0348 41.2821 66.0044C42.2517 66.974 43.5666 67.5189 44.9378 67.5194ZM44.9378 58.1994C45.7584 58.1994 46.5607 58.4427 47.243 58.8987C47.9254 59.3546 48.4572 60.0026 48.7713 60.7608C49.0853 61.519 49.1675 62.3533 49.0074 63.1582C48.8473 63.9631 48.4521 64.7024 47.8718 65.2827C47.2915 65.863 46.5522 66.2582 45.7473 66.4183C44.9424 66.5784 44.1081 66.4962 43.3499 66.1822C42.5917 65.8681 41.9437 65.3363 41.4878 64.654C41.0318 63.9716 40.7885 63.1694 40.7885 62.3487C40.7906 61.2489 41.2284 60.1947 42.0061 59.417C42.7838 58.6393 43.8379 58.2015 44.9378 58.1994Z",
    fill: "url(#paint47_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.967 180.887C291.989 180.887 292.989 180.584 293.839 180.016C294.69 179.448 295.352 178.64 295.744 177.695C296.135 176.751 296.238 175.711 296.038 174.708C295.839 173.705 295.346 172.784 294.623 172.06C293.9 171.337 292.978 170.845 291.975 170.645C290.972 170.446 289.933 170.548 288.988 170.94C288.043 171.331 287.236 171.994 286.667 172.844C286.099 173.694 285.796 174.694 285.796 175.717C285.797 177.088 286.341 178.403 287.311 179.372C288.281 180.342 289.596 180.887 290.967 180.887ZM290.967 171.567C291.787 171.567 292.59 171.811 293.272 172.267C293.954 172.723 294.486 173.371 294.8 174.129C295.114 174.887 295.196 175.721 295.036 176.526C294.876 177.331 294.481 178.07 293.901 178.651C293.32 179.231 292.581 179.626 291.776 179.786C290.971 179.946 290.137 179.864 289.379 179.55C288.621 179.236 287.973 178.704 287.517 178.022C287.061 177.34 286.817 176.537 286.817 175.717C286.819 174.617 287.257 173.563 288.035 172.785C288.813 172.007 289.867 171.569 290.967 171.567Z",
    fill: "url(#paint48_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.481 164.459C383.108 164.459 384.698 163.976 386.051 163.072C387.404 162.169 388.458 160.884 389.08 159.381C389.703 157.878 389.866 156.224 389.549 154.629C389.231 153.033 388.448 151.568 387.298 150.417C386.147 149.267 384.682 148.484 383.086 148.166C381.491 147.849 379.837 148.012 378.334 148.634C376.831 149.257 375.546 150.311 374.643 151.664C373.739 153.017 373.256 154.607 373.256 156.234C373.259 158.414 374.126 160.505 375.668 162.047C377.21 163.589 379.301 164.456 381.481 164.459ZM381.481 149.641C382.785 149.641 384.06 150.028 385.144 150.752C386.228 151.477 387.073 152.506 387.572 153.711C388.071 154.915 388.201 156.241 387.947 157.52C387.693 158.798 387.065 159.973 386.143 160.895C385.221 161.817 384.046 162.445 382.768 162.699C381.489 162.953 380.163 162.823 378.959 162.324C377.754 161.825 376.725 160.98 376 159.896C375.276 158.812 374.889 157.537 374.889 156.234C374.892 154.486 375.588 152.811 376.823 151.575C378.059 150.34 379.734 149.644 381.481 149.641Z",
    fill: "url(#paint49_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.041 239.241C453.011 239.241 453.96 238.953 454.767 238.414C455.574 237.875 456.203 237.108 456.574 236.211C456.946 235.315 457.043 234.328 456.853 233.376C456.664 232.424 456.197 231.55 455.51 230.864C454.824 230.178 453.95 229.71 452.998 229.521C452.046 229.332 451.059 229.429 450.163 229.8C449.266 230.172 448.5 230.8 447.961 231.607C447.421 232.414 447.134 233.363 447.134 234.334C447.135 235.635 447.652 236.882 448.572 237.802C449.492 238.722 450.74 239.239 452.041 239.241ZM452.041 230.419C452.817 230.419 453.577 230.649 454.223 231.081C454.869 231.512 455.372 232.126 455.669 232.843C455.967 233.561 456.045 234.351 455.893 235.113C455.741 235.875 455.367 236.574 454.818 237.124C454.269 237.673 453.569 238.047 452.807 238.199C452.045 238.35 451.255 238.272 450.538 237.975C449.82 237.678 449.206 237.174 448.775 236.529C448.343 235.883 448.113 235.123 448.113 234.346C448.112 233.83 448.214 233.319 448.411 232.842C448.608 232.366 448.897 231.932 449.262 231.567C449.627 231.202 450.06 230.913 450.537 230.715C451.014 230.517 451.525 230.416 452.041 230.416V230.419Z",
    fill: "url(#paint50_radial_4700_27908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.438 26.7848C127.064 26.7848 128.655 26.3024 130.007 25.3986C131.36 24.4948 132.414 23.2103 133.037 21.7073C133.659 20.2044 133.822 18.5506 133.505 16.955C133.187 15.3595 132.404 13.8939 131.254 12.7436C130.103 11.5933 128.638 10.81 127.042 10.4926C125.447 10.1752 123.793 10.3381 122.29 10.9606C120.787 11.5832 119.502 12.6374 118.599 13.99C117.695 15.3427 117.212 16.9329 117.212 18.5597C117.215 20.7404 118.082 22.8311 119.624 24.3732C121.166 25.9152 123.257 26.7825 125.438 26.7848ZM125.438 11.9676C126.741 11.9676 128.016 12.3542 129.1 13.0786C130.184 13.8029 131.029 14.8325 131.528 16.037C132.027 17.2415 132.157 18.567 131.903 19.8457C131.649 21.1245 131.021 22.2991 130.099 23.221C129.177 24.1429 128.002 24.7707 126.724 25.0251C125.445 25.2794 124.12 25.1489 122.915 24.65C121.71 24.151 120.681 23.3061 119.957 22.222C119.232 21.138 118.846 19.8635 118.846 18.5597C118.848 16.8122 119.544 15.1372 120.779 13.9015C122.015 12.6659 123.69 11.9705 125.438 11.9676Z",
    fill: "url(#paint51_radial_4700_27908)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(398.175 95.6828) rotate(180) scale(320.049 266.792)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#E3F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAECFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.455 191.847) rotate(180) scale(115.798 115.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(389.07 164.653) rotate(173.923) scale(66.0783 66.2742)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(679.191 195.746) scale(113.461 113.442)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(956.445 208.694) rotate(5.95292) scale(65.892 66.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4700_27908",
    x1: 282.362,
    y1: 54.0441,
    x2: 272.819,
    y2: 173.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#FFCE5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#FF8B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF713E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4700_27908",
    x1: 334.634,
    y1: 126.174,
    x2: 334.634,
    y2: 50.4938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4700_27908",
    x1: 290.964,
    y1: 126.174,
    x2: 290.964,
    y2: 50.4938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4700_27908",
    x1: 247.297,
    y1: 126.177,
    x2: 247.297,
    y2: 50.4867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4700_27908",
    x1: 203.611,
    y1: 126.156,
    x2: 203.611,
    y2: 50.4966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#FFD546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#FFD948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB49"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.541 55.8026) rotate(180) scale(26.4759 26.4419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-936.528 253.442) rotate(172.298) scale(18.8759 37.057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(506.779 336.327) rotate(90) scale(26.4203 26.4529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(487.254 208.226) rotate(82.2674) scale(139.434 5.03323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(752.218 -128.686) scale(26.4759 26.4419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(782.693 -258.921) rotate(-7.70013) scale(18.8794 37.0757)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(317.959 -265.993) rotate(-90) scale(26.4203 26.4529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(417.964 -134.285) rotate(-97.7326) scale(139.577 5.03324)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.423 54.8187) rotate(180) scale(12.8659 12.8658)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199.144 103.443) rotate(180) scale(12.8793)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.468 77.7993) rotate(180) scale(12.8658)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4700_27908",
    x1: 129.04,
    y1: 187.771,
    x2: 78.0344,
    y2: 345.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#E45FA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BD49E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE41FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4700_27908",
    x1: 127.815,
    y1: 188.876,
    x2: 81.4353,
    y2: 340.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB4B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#D43D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#A029C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C22DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4700_27908",
    x1: 147.496,
    y1: 237.878,
    x2: 116.357,
    y2: 322.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D47AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#475EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#8A98D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C9AD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4700_27908",
    x1: 89.063,
    y1: 340.84,
    x2: 29.1863,
    y2: 340.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D47AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#475EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#8A98D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C9AD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4700_27908",
    x1: 126.382,
    y1: 185.653,
    x2: -4.3555,
    y2: 299.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#E45FA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BD49E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE41FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4700_27908",
    x1: 118.345,
    y1: 236.164,
    x2: 114.963,
    y2: 276.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB4B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#D43D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#A029C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C22DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4700_27908",
    x1: 105.742,
    y1: 185.415,
    x2: -23.5312,
    y2: 243.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB4B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#D43D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#A029C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C22DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4700_27908",
    x1: 100.189,
    y1: 167.443,
    x2: -30.0775,
    y2: 276.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#E45FA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BD49E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE41FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4700_27908",
    x1: 100.26,
    y1: 167.479,
    x2: -32.0863,
    y2: 272.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#D85376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A23EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D35D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4700_27908",
    x1: 73.5537,
    y1: 170.439,
    x2: 129.311,
    y2: 160.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#240973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4700_27908",
    x1: 45.3139,
    y1: 150.877,
    x2: 92.787,
    y2: 86.5253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#240973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4700_27908",
    x1: 43.8217,
    y1: 149.789,
    x2: 91.7145,
    y2: 85.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#240973"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.0446 57.5393) rotate(180) scale(57.8265 57.8424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4700_27908",
    x1: 59.0976,
    y1: 160.778,
    x2: 122.437,
    y2: 129.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#240973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4700_27908",
    x1: 50.5414,
    y1: 154.629,
    x2: 104.404,
    y2: 148.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#240973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4700_27908",
    x1: 268.721,
    y1: 306.46,
    x2: 268.721,
    y2: 226.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D47AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#475EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#8A98D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C9AD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4700_27908",
    x1: 237.495,
    y1: 306.471,
    x2: 237.495,
    y2: 219.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#3C52A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B88C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4700_27908",
    x1: 388.845,
    y1: 290.965,
    x2: 372.532,
    y2: 290.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#240973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4700_27908",
    x1: 380.166,
    y1: 293.139,
    x2: 339.927,
    y2: 293.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#240973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4700_27908",
    x1: 344.925,
    y1: 308.466,
    x2: 358.061,
    y2: 258.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D47AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#475EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#8A98D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C9AD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4700_27908",
    x1: 342.502,
    y1: 306.405,
    x2: 376.067,
    y2: 260.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#3C52A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B88C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4700_27908",
    x1: 423.191,
    y1: 321.01,
    x2: 171.564,
    y2: 321.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#240973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4700_27908",
    x1: 238.751,
    y1: 320.918,
    x2: 37.8532,
    y2: 320.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#240973"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(431.274 251.241) rotate(180) scale(235.346 234.932)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(402.832 271.367) rotate(180) scale(241.7 242)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.251 150.895) rotate(180) scale(5.17073 5.17074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9378 62.3487) rotate(180) scale(5.17073 5.17074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(290.967 175.706) rotate(180) scale(5.17073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(381.481 156.234) rotate(180) scale(8.22514 8.22515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(452.041 234.343) rotate(180) scale(4.89724 4.89723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_4700_27908",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.438 18.5597) rotate(180) scale(8.22515 8.22514)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#9DC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C4FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4700_27908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 473,
    height: 337.086,
    fill: "white",
    transform: "matrix(-1 0 0 1 473 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewFeedbackImg);
export default __webpack_public_path__ + "static/media/review-feedback-img.8cb99e8da64f45862598a0ef9b659afc.svg";
export { ForwardRef as ReactComponent };